<nz-card nzBorderless class="customer-details-card">
  <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
    <div class="customer-id">
      <span class="text-gray-500 text-sm mb-1 block">Customer ID</span>
      <h1 class="text-2xl font-semibold m-0 text-primary">{{ customer?.customer_id }}</h1>
    </div>
    <div class="flex gap-3">
      <button nz-button nzType="primary" aria-label="Login as customer" nzSize="default" class="px-5 shadow-sm">
        <i nz-icon nzType="login" class="mr-1"></i>Login
      </button>
      <button nz-button nzType="primary" aria-label="Edit customer details" nzSize="default" class="px-5 shadow-sm"
        (click)="editCustomer()">
        <i nz-icon nzType="edit" class="mr-1"></i>Edit
      </button>
      <button nz-button nzType="primary" aria-label="Manage customer features" nzSize="default" class="px-5 shadow-sm"
        (click)="openFeatures()">
        <i nz-icon nzType="appstore" class="mr-1"></i>Features
      </button>
      <button nz-button nzType="primary" [nzDanger]="customer?.is_active" [ngStyle]="!customer?.is_active ? {
        'background-color': '#28a745',
        'border-color': '#28a745',
        'color': '#fff'
      } : {}" class="px-5 shadow-sm" aria-label="Deactivate customer" nzSize="default" nz-popconfirm
        [nzPopconfirmTitle]="customer?.is_active ? 'Are you sure you want to deactivate this customer?' : 'Are you sure you want to activate this customer?'"
        nzPopconfirmPlacement="bottom" (nzOnConfirm)="deactivateCustomer()">
        <i nz-icon [nzType]="customer?.is_active ? 'stop' : 'check'" class="mr-1"></i>
        {{ customer?.is_active ? 'Deactivate' : 'Activate' }}
      </button>
    </div>
  </div>

  <!-- Customer Details Section -->
  <div class="bg-white rounded-lg border border-gray-200 overflow-hidden mb-6 shadow-sm">
    <div class="bg-gray-50 px-6 py-3 border-b border-gray-200">
      <h2 class="text-lg font-medium m-0 text-primary">Customer Information</h2>
    </div>
    <div class="p-4">
      <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
        <div class="flex items-center">
          <span class="text-gray-500 w-32 text-base ">Company Name:</span>
          <span class="font-medium text-base">{{ customer?.company_name }}</span>
        </div>
        <div class="flex items-center">
          <span class="text-gray-500 w-32 text-base">Contact Person:</span>
          <span class="font-medium text-base">{{ customer?.contact_person }}</span>
        </div>
        <div class="flex items-center">
          <span class="text-gray-500 w-32 text-base">Email:</span>
          <span class="font-medium text-base">{{ customer?.contact_email }}</span>
        </div>
        <div class="flex items-center">
          <span class="text-gray-500 w-32 text-base">Contact:</span>
          <span class="font-medium text-base">{{ customer?.contact_number }}</span>
        </div>
        <div class="flex items-center">
          <span class="text-gray-500 w-32 text-sm">Compliance Level:</span>
          <span class="inline-flex items-center px-2 py-0.5 rounded-full bg-blue-50 text-primary text-sm font-medium">
            {{ customer?.compliance_level || 'N/A' }}
          </span>
        </div>
        <div class="flex items-center">
          <span class="text-gray-500 w-32 text-base">Status:</span>
          <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium gap-1" [ngClass]="{
              'bg-green-50 text-green-600': customer?.is_active,
              'bg-red-50 text-red-600': !customer?.is_active
            }">
            <i *ngIf="customer?.is_active" nz-icon nzType="check-circle" aria-hidden="true"></i>
            <i *ngIf="!customer?.is_active" nz-icon nzType="close-circle" aria-hidden="true"></i>
            {{ customer?.is_active ? 'Active' : 'Inactive' }}
          </span>
        </div>
        <div class="flex items-center">
          <span class="text-gray-500 w-32 text-base">Application:</span>
          <nz-select [(ngModel)]="selectedApplicationId" (ngModelChange)="onApplicationChange($event)"
            nzPlaceHolder="Select Application" class="w-48" nzSize="default"
            [nzDisabled]="customerApplications.length === 0">
            <nz-option *ngFor="let app of customerApplications" [nzValue]="app.id" [nzLabel]="app.name">
            </nz-option>
          </nz-select>
          <span *ngIf="customerApplications.length === 0" class="text-gray-400 text-sm ml-2">
            No applications available
          </span>
        </div>
      </div>
    </div>
  </div>

  <nz-divider></nz-divider>

  <!-- Tabs Section -->
  <nz-tabset [(nzSelectedIndex)]="selectedTabIndex" (nzSelectedIndexChange)="onTabChange($event)" nzSize="large"
    class="customer-tabs" [nzTabBarGutter]="24" [nzAnimated]="true">
    <nz-tab *ngFor="let tab of availableTabs; let i = index" [nzTitle]="tab">
      <ng-template nz-tab>
        <div class="pt-4">
          <ng-container *ngIf="selectedTabIndex === i">
            <ng-container *ngIf="getTabComponentIndex(i) === 0">
              <app-assets></app-assets>
            </ng-container>
            <ng-container *ngIf="getTabComponentIndex(i) === 1">
              <app-devices></app-devices>
            </ng-container>
            <ng-container *ngIf="getTabComponentIndex(i) === 2">
              <app-incidents></app-incidents>
            </ng-container>
            <ng-container *ngIf="getTabComponentIndex(i) === 3">
              <app-users></app-users>
            </ng-container>
            <ng-container *ngIf="getTabComponentIndex(i) === 4">
              <app-assetSensorMapping></app-assetSensorMapping>
            </ng-container>
            <ng-container *ngIf="getTabComponentIndex(i) === 5">
              <app-group-management></app-group-management>
            </ng-container>
            <ng-container *ngIf="getTabComponentIndex(i) === 6">
              <app-reports></app-reports>
            </ng-container>
            <ng-container *ngIf="getTabComponentIndex(i) === 7">
              <app-master></app-master>
            </ng-container>
          </ng-container>
        </div>
      </ng-template>
    </nz-tab>
  </nz-tabset>
</nz-card>

<!-- Edit Customer Modal -->
<nz-modal [(nzVisible)]="isVisible" [nzTitle]="'Edit Customer'" (nzOnCancel)="isVisible = false" [nzWidth]="500"
  [nzClosable]="!isConfirmLoading" [nzMaskClosable]="!isConfirmLoading">
  <ng-container *nzModalContent>
    <form nz-form [formGroup]="form" role="form" aria-labelledby="form" class="grid grid-cols-1 gap-y-4">
      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="company_name">Company Name</nz-form-label>
        <nz-form-control [nzErrorTip]="'Company Name is required'">
          <input nz-input formControlName="company_name" class="w-full" maxlength="50"
            placeholder="Enter Company Name" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="contact_person">Contact Person</nz-form-label>
        <nz-form-control [nzErrorTip]="'Contact Person is required'">
          <input nz-input formControlName="contact_person" class="w-full" maxlength="50"
            placeholder="Enter Contact Person" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="contact_email">Email</nz-form-label>
        <nz-form-control [nzErrorTip]="'Email is required'">
          <input nz-input type="email" formControlName="contact_email" class="w-full" placeholder="Enter Email" />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="contact_number">Contact Number</nz-form-label>
        <nz-form-control [nzErrorTip]="contactErrorTpl">
          <input nz-input type="text" formControlName="contact_number" class="w-full" maxlength="10"
            placeholder="Enter Contact number" />
        </nz-form-control>
        <ng-template #contactErrorTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            Contact Number is required
          </ng-container>
          <ng-container *ngIf="control.hasError('pattern')">
            Please enter exactly 10 digits
          </ng-container>
        </ng-template>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzFor="compliance_level">Compliance Level</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="compliance_level" nzMode="multiple" nzPlaceHolder="Select compliance levels"
            class="w-full">
            <nz-option *ngFor="let option of complianceLevelOptions" [nzValue]="option.value" [nzLabel]="option.label"
              [nzDisabled]="isComplianceOptionDisabled(option.value)"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="w-full mb-0">
        <nz-form-label class="text-left" nzRequired nzFor="application_id">Application</nz-form-label>
        <nz-form-control [nzErrorTip]="'Application is required'">
          <nz-select formControlName="application_id" nzMode="multiple" nzPlaceHolder="Select applications"
            class="w-full" nzShowSearch>
            <nz-option *ngFor="let app of applications" [nzValue]="app.id" [nzLabel]="app.name"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </form>
  </ng-container>

  <div *nzModalFooter>
    <button nz-button nzType="default" (click)="isVisible = false" [disabled]="isConfirmLoading">Cancel</button>
    <button nz-button nzType="primary" (click)="onSubmit()" [nzLoading]="isConfirmLoading"
      [disabled]="isConfirmLoading">Update</button>
  </div>
</nz-modal>

<!-- Customer Features Component -->
<app-customer-features #customerFeatures></app-customer-features>